import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CheckInService } from 'app/Shared/Services/check-in.service';
import { ReservationService } from 'app/Shared/Services/reservation.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FichedepoliceComponent } from '../fichedepolice/fichedepolice.component';
import Swal from 'sweetalert2';
import { Country } from 'app/Shared/models/country.model';
import { Client } from 'app/Shared/models/client.model';
import { Email } from 'app/Shared/models/email.model';
import { Phone } from 'app/Shared/models/phone.model';
import { Document } from 'app/Shared/models/document.model';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

interface GuestFormData {
  client: any;
  dayBirth: number | null;
  monthBirth: number | null;
  yearBirth: number | null;
  docType: any;
  subDocType: any;
  document: Document;
  filteredSubDocTypes: any[];
  countrySearchResults: Country[];
  nationalitySearchResults: Country[];
  showError: boolean;
}

@Component({
  selector: 'app-fast-check-in',
  templateUrl: './fast-check-in.component.html',
  styleUrls: ['./fast-check-in.component.scss'],
  providers: [DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class FastCheckInComponent implements OnInit {
  
  reservationId: string;
  isLoading: boolean = true;
  errorMessage: string = '';
  
  // Reservation data
  OrderGeted: any;
  Item: any;
  resa: any;
  hotelName: string;
  hotelLogo: string;
  
  // Display data
  formattedDatearrived: string;
  formattedDatedepart: string;
  formattedDateCreation: string;
  Numberofneight: number = 0;
  roomTypeinvoiced: string;
  NumberAdults: number = 0;
  NumberKids: number = 0;
  NumberBbKids: number = 0;
  
  // Guest information
  mainGuest: any;
  beneficiaries: any[] = [];

  currentYear = new Date().getFullYear();

  // Guest form data - now stores ALL guests simultaneously
  guestFormData: Map<number, GuestFormData> = new Map();

  // Legacy properties kept for backward compatibility
  currentEditingGuestIndex: number = -1;
  ClientUpdaed: Client;
  ClientSeleted: boolean = false;
  ClientComplete: boolean = false;
  indxBene: any = undefined;
  
  // Track which guests have been completed
  completedGuests: Set<number> = new Set();
  isSubmitting: boolean = false;
  
  // Date of birth (legacy - kept for backward compatibility)
  DayCustomerBirthd: any;
  MounthCustomerBirthd: any;
  YearCustomerBirthd: any;
  
  // Document
  ListTypedocument: any[] = [];
  CustomerdocType: any;
  Customerdocument: Document = {} as Document;
  
  // Country/Nationality search results (legacy)
  countrySearchResults: Country[] = [];
  nationalitySearchResults: Country[] = [];
  
  // Search subjects for debouncing
  private countrySearchSubject = new Subject<string>();
  private nationalitySearchSubject = new Subject<string>();
  
  // Date selectors
  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: { name: string; value: number }[] = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 }
  ];
  years: number[] = Array.from({ length: 121 }, (_, i) => this.currentYear - i);
  
  // Pre-defined countries/nationalities
  Countries: any[] = [
    { coutryid: 504, name: "Maroc", alpha2: "ma", alpha3: "mar", nameEn: "Morocco" },
    { coutryid: 250, name: "France", alpha2: "fr", alpha3: "fra", nameEn: "France" },
    { coutryid: 276, name: "Allemagne", alpha2: "de", alpha3: "deu", nameEn: "Germany" },
    { coutryid: 826, name: "Royaume-Uni", alpha2: "gb", alpha3: "gbr", nameEn: "United Kingdom" },
    { coutryid: 840, name: "États-Unis", alpha2: "us", alpha3: "usa", nameEn: "United States" },
    { coutryid: 56, name: "Belgique", alpha2: "be", alpha3: "bel", nameEn: "Belgium" },
    { coutryid: 784, name: "Émirats arabes unis", alpha2: "ae", alpha3: "are", nameEn: "United Arab Emirates" }
  ];
  
  Nationalities: any[] = [...this.Countries];

  ListSubDocumentTypes: any[] = [];
  filteredSubDocTypes: any[] = [];
  CustomerSubDocType: any;
  
  constructor(
    private route: ActivatedRoute,
    private checkInService: CheckInService,
    private reservationService: ReservationService,
    private datePipe: DatePipe,
    private modalService: NgbModal
  ) {
    this.reservationId = this.route.snapshot.params['id'];
    
    // Setup debounced country search
    this.countrySearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      if (searchTerm && searchTerm.length >= 2) {
        this.searchCountries(searchTerm, 'country');
      } else {
        this.countrySearchResults = [];
      }
    });
    
    // Setup debounced nationality search
    this.nationalitySearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      if (searchTerm && searchTerm.length >= 2) {
        this.searchCountries(searchTerm, 'nationality');
      } else {
        this.nationalitySearchResults = [];
      }
    });
  }

  async ngOnInit(): Promise<void> {
    if (!this.reservationId) {
      this.errorMessage = 'No reservation ID provided';
      this.isLoading = false;
      return;
    }
    
    await this.loadReservationData();
    await this.getDocumentTypes();
    await this.getSubDocumentTypes();
    
    // Initialize form data for ALL guests
    this.initializeAllGuestForms();
  }

  async getSubDocumentTypes(): Promise<void> {
    try {
      this.ListSubDocumentTypes = await this.checkInService.getAllSubDocumentTypes().toPromise() || [];
    } catch (error) {
      console.error('Error loading sub document types:', error);
      this.ListSubDocumentTypes = [];
    }
  }

  onDocTypeChange(): void {
    this.CustomerSubDocType = null;
    
    if (this.CustomerdocType && this.CustomerdocType.docTypeId !== undefined) {
      this.filteredSubDocTypes = this.ListSubDocumentTypes.filter(
        subType => subType.docType?.docTypeId === this.CustomerdocType.docTypeId
      );
    } else {
      this.filteredSubDocTypes = [];
    }
  }

  comparSubDocTypeFn(subDocA: any, subDocB: any): boolean {
    return subDocA && subDocB ? subDocA.subDocTypeId === subDocB.subDocTypeId : subDocA === subDocB;
  }

  async loadReservationData(): Promise<void> {
    try {
      this.isLoading = true;
      
      this.OrderGeted = await this.checkInService.getOrderbyItemId(this.reservationId).toPromise();
      
      if (!this.OrderGeted) {
        this.errorMessage = 'Reservation not found';
        this.isLoading = false;
        return;
      }

      this.hotelName = this.OrderGeted?.user?.group?.name || '';
      this.hotelLogo = this.OrderGeted?.user?.group?.transactionRef || '';
      console.log("The hotel name is : ", this.hotelName);
      console.log("The logo path of the hotel is : ", this.hotelLogo);
      
      this.OrderGeted.items.forEach((item: any) => {
        if (item.itemId == this.reservationId) {
          this.Item = item;
        }
      });
      
      if (!this.Item) {
        this.errorMessage = 'Reservation item not found';
        this.isLoading = false;
        return;
      }
      
      this.resa = await this.reservationService.getReservationID(this.reservationId).toPromise();
      
      this.processDateInfo();
      this.processBeneficiaries();
      this.roomTypeinvoiced = this.Item.name;
      
      this.isLoading = false;
      
    } catch (error) {
      console.error('Error loading reservation:', error);
      this.errorMessage = 'Unable to load reservation. Please check your link and try again.';
      this.isLoading = false;
    }
  }

  processDateInfo(): void {
    if (!this.Item) return;
    
    let startServiceDate = this.Item.startService.split("-").reverse().join("-");
    let startDate = new Date(startServiceDate);
    this.formattedDatearrived = this.datePipe.transform(startDate, "EEE, MMM d, y");
    
    let endServiceDate = this.Item.endService.split("-").reverse().join("-");
    let endDate = new Date(endServiceDate);
    this.formattedDatedepart = this.datePipe.transform(endDate, "EEE, MMM d, y");
    
    const timeDiff = endDate.getTime() - startDate.getTime();
    this.Numberofneight = Math.ceil(timeDiff / (1000 * 3600 * 24));
    
    if (this.Item.creationDate) {
      const confirmedDateParts = this.Item.creationDate.split(" ");
      const dateParts = confirmedDateParts[0].split("-").map(Number);
      const timeParts = confirmedDateParts[1]?.split(":").map(Number) || [0, 0];
      const creationDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], timeParts[0], timeParts[1]);
      this.formattedDateCreation = this.datePipe.transform(creationDate, "EEE, MMM d, y HH:mm");
    }
  }

  processBeneficiaries(): void {
    if (!this.Item || !this.Item.beneficiaries) return;
    
    this.beneficiaries = this.Item.beneficiaries;
    this.mainGuest = this.Item.beneficiaries[0];
    
    this.NumberAdults = 0;
    this.NumberKids = 0;
    this.NumberBbKids = 0;
    
    this.Item.beneficiaries.forEach((ben: any) => {
      if (ben.ref == null) {
        this.NumberAdults++;
      } else {
        if (!ben.ref.includes("CHD")) {
          this.NumberAdults++;
        } else {
          let age = ben.ref.split(":")[2];
          if (Number(age) >= 3) {
            this.NumberKids++;
          } else {
            this.NumberBbKids++;
          }
        }
      }
    });
    
    // Check which guests are already complete
    this.beneficiaries.forEach((guest, index) => {
      if (this.isGuestComplete(guest)) {
        this.completedGuests.add(index);
      }
    });
  }

  // Initialize form data for ALL guests at once
  initializeAllGuestForms(): void {
    if (!this.beneficiaries) return;
    
    this.beneficiaries.forEach((guest, index) => {
      this.initializeGuestForm(guest, index);
    });
  }


  initializeGuestForm(beneficiary: Client, index: number): void {
    // Deep copy to avoid mutating original
    const clientCopy: any = JSON.parse(JSON.stringify(beneficiary));
    
    // Initialize mainEmail if null
    if (clientCopy.mainEmail == null) {
      clientCopy.mainEmail = {} as Email;
      clientCopy.mainEmail.address = "";
    }
    
    // Initialize mainPhone if null
    if (clientCopy.mainPhone == null) {
      clientCopy.mainPhone = {} as Phone;
      clientCopy.mainPhone.number = "";
    }
    
    // Initialize country if null
    if (clientCopy.country == null) {
      clientCopy.country = {} as Country;
      clientCopy.country.name = "";
    }
    
    // Initialize nationality as Country object if null/undefined or if it's a string
    if (!clientCopy.nationality) {
      clientCopy.nationality = { name: "" } as Country;
    } else if (typeof clientCopy.nationality === 'string') {
      // Convert string nationality to Country object
      const natName = clientCopy.nationality;
      const foundNat = this.Nationalities.find(n => n.name === natName || n.nameEn === natName);
      clientCopy.nationality = foundNat ? { ...foundNat } : { name: natName } as Country;
    }
    
    // Initialize title if null
    if (!clientCopy.title) {
      clientCopy.title = { titleId: null, name: 'No Title', nameEn: 'No Title' };
    }
    
    // Initialize documents array if null
    if (!clientCopy.documents) {
      clientCopy.documents = [];
    }

    // ...existing code for date parsing and document handling...
    let dayBirth: number | null = null;
    let monthBirth: number | null = null;
    let yearBirth: number | null = null;
    let docType: any = null;
    let subDocType: any = null;
    let document: Document = {} as Document;
    let filteredSubDocTypes: any[] = [];
    
    // Load existing document if present
    if (clientCopy.documents && clientCopy.documents.length > 0) {
      const firstDoc = clientCopy.documents[0];
      document = {
        id: firstDoc.id,
        description: firstDoc.description || null,
        type: firstDoc.type ? { ...firstDoc.type } : null,
        code: firstDoc.code || '',
        expire: firstDoc.expire,
        link: firstDoc.link,
        valid: firstDoc.valid
      } as Document;
      
      // Set docType for the dropdown
      if (firstDoc.type && firstDoc.type.docTypeId !== undefined) {
        docType = this.ListTypedocument.find(
          dt => dt.docTypeId === firstDoc.type.docTypeId
        ) || firstDoc.type;
        
        // Filter subdocument types for this document type
        filteredSubDocTypes = this.ListSubDocumentTypes.filter(
          subType => subType.docType?.docTypeId === firstDoc.type.docTypeId
        );
        
        // Set subDocType if subdocumentType exists
        if ((firstDoc as any).subdocumentType) {
          subDocType = filteredSubDocTypes.find(
            st => st.subDocTypeId === (firstDoc as any).subdocumentType.subDocTypeId
          ) || (firstDoc as any).subdocumentType;
        }
      }
    }
    
    // Parse date of birth if present
    if (clientCopy.dob !== null && clientCopy.dob !== undefined) {
      let parts = clientCopy.dob.split('-');
      if (parts.length === 3) {
        dayBirth = +parts[0];
        monthBirth = +parts[1];
        yearBirth = +parts[2];
      }
    }

    this.guestFormData.set(index, {
      client: clientCopy,
      dayBirth,
      monthBirth,
      yearBirth,
      docType,
      subDocType,
      document,
      filteredSubDocTypes,
      countrySearchResults: [],
      nationalitySearchResults: [],
      showError: false
    });
  }



  // Get form data for a specific guest
  getGuestFormData(index: number): GuestFormData | undefined {
    return this.guestFormData.get(index);
  }

  // Handle country input for a specific guest
  onGuestCountryInput(event: any, index: number): void {
    const value = event.target.value;
    const formData = this.guestFormData.get(index);
    if (!formData) return;
    
    if (value && value.length >= 2) {
      this.reservationService.getCountryByName(value).subscribe(
        (results) => {
          formData.countrySearchResults = results || [];
        },
        (error) => {
          console.error('Error searching countries:', error);
          formData.countrySearchResults = [];
        }
      );
    } else {
      formData.countrySearchResults = [];
    }
  }

  // Handle nationality input for a specific guest
  onGuestNationalityInput(event: any, index: number): void {
    const value = event.target.value;
    const formData = this.guestFormData.get(index);
    if (!formData) return;
    
    if (value && value.length >= 2) {
      this.reservationService.getCountryByName(value).subscribe(
        (results) => {
          formData.nationalitySearchResults = results || [];
        },
        (error) => {
          console.error('Error searching nationalities:', error);
          formData.nationalitySearchResults = [];
        }
      );
    } else {
      formData.nationalitySearchResults = [];
    }
  }

  // Select country from search results for a specific guest
  selectGuestCountryFromSearch(country: Country, index: number): void {
    const formData = this.guestFormData.get(index);
    if (!formData) return;
    
    formData.client.country = country;
    formData.countrySearchResults = [];
  }

  // Select nationality from search results for a specific guest
  selectGuestNationalityFromSearch(nationality: Country, index: number): void {
    const formData = this.guestFormData.get(index);
    if (!formData) return;
    
    formData.client.nationality = { ...nationality };
    formData.nationalitySearchResults = [];
  }


  // Select country from flag buttons for a specific guest
  selectGuestCountry(countryIndex: number, guestIndex: number): void {
    const formData = this.guestFormData.get(guestIndex);
    if (!formData) return;
    
    formData.client.country = { ...this.Countries[countryIndex] };
    formData.countrySearchResults = [];
  }

  // Select nationality from flag buttons for a specific guest
  selectGuestNationality(nationalityIndex: number, guestIndex: number): void {
    const formData = this.guestFormData.get(guestIndex);
    if (!formData) return;
    
    // Set nationality as the full Country object
    formData.client.nationality = { ...this.Nationalities[nationalityIndex] };
    formData.nationalitySearchResults = [];
  }

  // Handle document type change for a specific guest
  onGuestDocTypeChange(index: number): void {
    const formData = this.guestFormData.get(index);
    if (!formData) return;
    
    formData.subDocType = null;
    
    if (formData.docType && formData.docType.docTypeId !== undefined) {
      formData.filteredSubDocTypes = this.ListSubDocumentTypes.filter(
        subType => subType.docType?.docTypeId === formData.docType.docTypeId
      );
    } else {
      formData.filteredSubDocTypes = [];
    }
  }


  async saveGuest(index: number): Promise<boolean> {
    const formData = this.guestFormData.get(index);
    if (!formData) return false;
    
    formData.showError = false;
    
    // Validation - require firstName, lastName, country, and nationality
    const nationalityName = typeof formData.client.nationality === 'string' 
      ? formData.client.nationality 
      : formData.client.nationality?.name;
    
    if (!formData.client.firstName?.trim() || 
        !formData.client.lastName?.trim() || 
        !formData.client.country?.name?.trim() ||
        !nationalityName?.trim()) {
      formData.showError = true;
      return false;
    }
    
    // Ensure nationality is a Country object, not a string
    if (typeof formData.client.nationality === 'string') {
      const natName = formData.client.nationality;
      const foundNat = this.Nationalities.find(n => n.name === natName || n.nameEn === natName);
      formData.client.nationality = foundNat ? { ...foundNat } : { name: natName } as Country;
    }
    
    // Build DOB string
    if (formData.dayBirth !== undefined && formData.dayBirth !== null &&
        formData.monthBirth !== undefined && formData.monthBirth !== null &&
        formData.yearBirth !== undefined && formData.yearBirth !== null) {
      formData.client.dob = `${formData.dayBirth}-${formData.monthBirth}-${formData.yearBirth}`;
    } else {
      formData.client.dob = null;
    }
    
    // ...existing code for title and documents handling...
    // Handle title
    if (formData.client.title) {
      const titleName = typeof formData.client.title === 'string' 
        ? formData.client.title 
        : formData.client.title.name;
      
      switch (titleName) {
        case 'Mr':
          formData.client.title = { titleId: 1, name: 'Mr', nameEn: 'Mr' };
          break;
        case 'Mme':
          formData.client.title = { titleId: 2, name: 'Mme', nameEn: 'Mrs' };
          break;
        default:
          formData.client.title = { titleId: null, name: 'No Title', nameEn: 'No Title' };
      }
    } else {
      formData.client.title = { titleId: null, name: 'No Title', nameEn: 'No Title' };
    }
    
    // Handle documents
    if (formData.docType && formData.docType.docTypeId !== undefined) {
      formData.document.type = {
        docTypeId: formData.docType.docTypeId,
        name: formData.docType.name,
        nameEn: formData.docType.nameEn || null
      };
      
      if (formData.document.code && formData.document.code.trim() !== '') {
        if (!formData.client.documents) {
          formData.client.documents = [];
        }
        
        let subdocumentType = null;
        if (formData.subDocType && formData.subDocType.subDocTypeId) {
          subdocumentType = {
            subDocTypeId: formData.subDocType.subDocTypeId,
            name: formData.subDocType.name,
            nameEn: formData.subDocType.nameEn
          };
        }
        
        if (formData.document.id) {
          const existingDocIndex = formData.client.documents.findIndex(
            d => d.id === formData.document.id
          );
          if (existingDocIndex >= 0) {
            formData.client.documents[existingDocIndex] = { 
              ...formData.document,
              subdocumentType: subdocumentType
            } as any;
          } else {
            formData.client.documents.push({ 
              ...formData.document,
              subdocumentType: subdocumentType
            } as any);
          }
        } else {
          const existingTypeIndex = formData.client.documents.findIndex(
            d => d.type?.docTypeId === formData.docType.docTypeId
          );
          if (existingTypeIndex >= 0) {
            formData.client.documents[existingTypeIndex].code = formData.document.code;
            formData.client.documents[existingTypeIndex].type = formData.document.type;
            (formData.client.documents[existingTypeIndex] as any).subdocumentType = subdocumentType;
          } else {
            formData.client.documents.push({
              id: null,
              description: null,
              type: formData.document.type,
              code: formData.document.code,
              expire: null,
              link: null,
              valid: false,
              subdocumentType: subdocumentType
            } as any);
          }
        }
      }
    }
    
    // Filter out documents with no code or no type
    if (formData.client.documents && formData.client.documents.length > 0) {
      formData.client.documents = formData.client.documents.filter(d => {
        return d.type && d.type.docTypeId !== undefined && d.code && d.code.trim() !== '';
      });
    }
    
    // Update client name
    formData.client.name = `${formData.client.lastName} ${formData.client.firstName}`;
    
    try {
      await this.reservationService.updatedClient(formData.client).toPromise();
      
      // Refresh item data
      this.Item = await this.checkInService.getItembyId(this.Item.itemId).toPromise();
      
      // Update the beneficiary in the local array
      const updatedClient = await this.reservationService.getClientbyID(formData.client.id).toPromise();
      if (updatedClient) {
        this.Item.beneficiaries[index] = updatedClient;
        this.beneficiaries[index] = updatedClient;
        // Re-initialize the form data with updated client
        this.initializeGuestForm(updatedClient, index);
      }
      
      // Mark this guest as completed
      this.completedGuests.add(index);
      
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Saved',
      //   text: `Guest ${index + 1} information saved successfully.`,
      //   timer: 2000,
      //   showConfirmButton: false
      // });
      
      return true;
      
    } catch (error) {
      console.error('Error updating guest:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update guest information. Please try again.'
      });
      return false;
    }
  }

  isGuestComplete(guest: any): boolean {
    return !!(
      guest.firstName?.trim() && 
      guest.lastName?.trim() && 
      guest.country?.name?.trim() &&
      guest.nationality?.name
    );
  }

  // Legacy method - kept for backward compatibility
  editGuest(beneficiary: Client, index: number): void {
    this.DayCustomerBirthd = null;
    this.MounthCustomerBirthd = null;
    this.YearCustomerBirthd = null;
    this.Customerdocument = {} as Document;
    this.CustomerdocType = null;
    this.CustomerSubDocType = null;
    this.filteredSubDocTypes = [];
    this.countrySearchResults = [];
    this.nationalitySearchResults = [];
    this.ClientComplete = false;

    // Deep copy to avoid mutating original
    this.ClientUpdaed = JSON.parse(JSON.stringify(beneficiary));
    this.indxBene = index;
    this.currentEditingGuestIndex = index;
    
    // Initialize mainEmail if null
    if (this.ClientUpdaed.mainEmail == null) {
      this.ClientUpdaed.mainEmail = {} as Email;
      this.ClientUpdaed.mainEmail.address = "";
    }
    
    // Initialize mainPhone if null
    if (this.ClientUpdaed.mainPhone == null) {
      this.ClientUpdaed.mainPhone = {} as Phone;
      this.ClientUpdaed.mainPhone.number = "";
    }
    
    // Initialize country if null
    if (this.ClientUpdaed.country == null) {
      this.ClientUpdaed.country = {} as Country;
      this.ClientUpdaed.country.name = "";
    }
    
    // Initialize nationality if null/undefined
    if (!this.ClientUpdaed.nationality) {
      this.ClientUpdaed.nationality = {} as any;
    }
    
    // Initialize title if null
    if (!this.ClientUpdaed.title) {
      this.ClientUpdaed.title = { titleId: null, name: 'No Title', nameEn: 'No Title' };
    }
    
    // Initialize documents array if null
    if (!this.ClientUpdaed.documents) {
      this.ClientUpdaed.documents = [];
    }
    
    // Load existing document if present
    if (this.ClientUpdaed.documents && this.ClientUpdaed.documents.length > 0) {
      const firstDoc = this.ClientUpdaed.documents[0];
      this.Customerdocument = {
        id: firstDoc.id,
        description: firstDoc.description || null,
        type: firstDoc.type ? { ...firstDoc.type } : null,
        code: firstDoc.code || '',
        expire: firstDoc.expire,
        link: firstDoc.link,
        valid: firstDoc.valid
      } as Document;
      
      // Set CustomerdocType for the dropdown
      if (firstDoc.type && firstDoc.type.docTypeId !== undefined) {
        this.CustomerdocType = this.ListTypedocument.find(
          dt => dt.docTypeId === firstDoc.type.docTypeId
        ) || firstDoc.type;
        
        // Filter subdocument types for this document type
        this.filteredSubDocTypes = this.ListSubDocumentTypes.filter(
          subType => subType.docType?.docTypeId === firstDoc.type.docTypeId
        );
        
        // Set CustomerSubDocType if subdocumentType exists
        if ((firstDoc as any).subdocumentType) {
          this.CustomerSubDocType = this.filteredSubDocTypes.find(
            st => st.subDocTypeId === (firstDoc as any).subdocumentType.subDocTypeId
          ) || (firstDoc as any).subdocumentType;
        }
      }
    }
    
    // Parse date of birth if present
    if (this.ClientUpdaed.dob !== null && this.ClientUpdaed.dob !== undefined) {
      let parts = this.ClientUpdaed.dob.split('-');
      if (parts.length === 3) {
        this.DayCustomerBirthd = +parts[0];
        this.MounthCustomerBirthd = +parts[1];
        this.YearCustomerBirthd = +parts[2];
      }
    }
    
    this.ClientSeleted = true;
  }

  // Country input handler (legacy)
  onCountryInput(event: any): void {
    const value = event.target.value;
    this.countrySearchSubject.next(value);
  }
  
  // Nationality input handler (legacy)
  onNationalityInput(event: any): void {
    const value = event.target.value;
    this.nationalitySearchSubject.next(value);
  }
  
  // Search countries from API
  async searchCountries(searchTerm: string, type: 'country' | 'nationality'): Promise<void> {
    try {
      const results = await this.reservationService.getCountryByName(searchTerm).toPromise();
      if (type === 'country') {
        this.countrySearchResults = results || [];
      } else {
        this.nationalitySearchResults = results || [];
      }
    } catch (error) {
      console.error('Error searching countries:', error);
      if (type === 'country') {
        this.countrySearchResults = [];
      } else {
        this.nationalitySearchResults = [];
      }
    }
  }
  
  // Select country from search results (legacy)
  selectCountryFromSearch(country: Country): void {
    this.ClientUpdaed.country = country;
    this.countrySearchResults = [];
  }
  
  // Select nationality from search results (legacy)
  selectNationalityFromSearch(nationality: Country): void {
    this.ClientUpdaed.nationality = nationality.name;
    this.nationalitySearchResults = [];
  }

  // Legacy method - kept for backward compatibility
  async saveCurrentGuestAndContinue(): Promise<boolean> {
    this.ClientComplete = false;
    
    // Validation - require firstName, lastName, and country
    if (!this.ClientUpdaed.firstName?.trim() || 
        !this.ClientUpdaed.lastName?.trim() || 
        !this.ClientUpdaed.country?.name?.trim()) {
      this.ClientComplete = true;
      return false;
    }
    
    // Build DOB string
    if (this.DayCustomerBirthd !== undefined && this.DayCustomerBirthd !== null &&
        this.MounthCustomerBirthd !== undefined && this.MounthCustomerBirthd !== null &&
        this.YearCustomerBirthd !== undefined && this.YearCustomerBirthd !== null) {
      this.ClientUpdaed.dob = `${this.DayCustomerBirthd}-${this.MounthCustomerBirthd}-${this.YearCustomerBirthd}`;
    } else {
      this.ClientUpdaed.dob = null;
    }
    
    // Handle title
    if (this.ClientUpdaed.title) {
      const titleName = typeof this.ClientUpdaed.title === 'string' 
        ? this.ClientUpdaed.title 
        : this.ClientUpdaed.title.name;
      
      switch (titleName) {
        case 'Mr':
          this.ClientUpdaed.title = { titleId: 1, name: 'Mr', nameEn: 'Mr' };
          break;
        case 'Mme':
          this.ClientUpdaed.title = { titleId: 2, name: 'Mme', nameEn: 'Mrs' };
          break;
        default:
          this.ClientUpdaed.title = { titleId: null, name: 'No Title', nameEn: 'No Title' };
      }
    } else {
      this.ClientUpdaed.title = { titleId: null, name: 'No Title', nameEn: 'No Title' };
    }
    
    // Handle documents
    if (this.CustomerdocType && this.CustomerdocType.docTypeId !== undefined) {
      this.Customerdocument.type = {
        docTypeId: this.CustomerdocType.docTypeId,
        name: this.CustomerdocType.name,
        nameEn: this.CustomerdocType.nameEn || null
      };
      
      if (this.Customerdocument.code && this.Customerdocument.code.trim() !== '') {
        if (!this.ClientUpdaed.documents) {
          this.ClientUpdaed.documents = [];
        }
        
        let subdocumentType = null;
        if (this.CustomerSubDocType && this.CustomerSubDocType.subDocTypeId) {
          subdocumentType = {
            subDocTypeId: this.CustomerSubDocType.subDocTypeId,
            name: this.CustomerSubDocType.name,
            nameEn: this.CustomerSubDocType.nameEn
          };
        }
        
        if (this.Customerdocument.id) {
          const existingDocIndex = this.ClientUpdaed.documents.findIndex(
            d => d.id === this.Customerdocument.id
          );
          if (existingDocIndex >= 0) {
            this.ClientUpdaed.documents[existingDocIndex] = { 
              ...this.Customerdocument,
              subdocumentType: subdocumentType
            } as any;
          } else {
            this.ClientUpdaed.documents.push({ 
              ...this.Customerdocument,
              subdocumentType: subdocumentType
            } as any);
          }
        } else {
          const existingTypeIndex = this.ClientUpdaed.documents.findIndex(
            d => d.type?.docTypeId === this.CustomerdocType.docTypeId
          );
          if (existingTypeIndex >= 0) {
            this.ClientUpdaed.documents[existingTypeIndex].code = this.Customerdocument.code;
            this.ClientUpdaed.documents[existingTypeIndex].type = this.Customerdocument.type;
            (this.ClientUpdaed.documents[existingTypeIndex] as any).subdocumentType = subdocumentType;
          } else {
            this.ClientUpdaed.documents.push({
              id: null,
              description: null,
              type: this.Customerdocument.type,
              code: this.Customerdocument.code,
              expire: null,
              link: null,
              valid: false,
              subdocumentType: subdocumentType
            } as any);
          }
        }
      }
    }
    
    // Filter out documents with no code or no type
    if (this.ClientUpdaed.documents && this.ClientUpdaed.documents.length > 0) {
      this.ClientUpdaed.documents = this.ClientUpdaed.documents.filter(d => {
        return d.type && d.type.docTypeId !== undefined && d.code && d.code.trim() !== '';
      });
    }
    
    // Update client name
    this.ClientUpdaed.name = `${this.ClientUpdaed.lastName} ${this.ClientUpdaed.firstName}`;
    
    try {
      await this.reservationService.updatedClient(this.ClientUpdaed).toPromise();
      
      // Refresh item data
      this.Item = await this.checkInService.getItembyId(this.Item.itemId).toPromise();
      
      // Update the beneficiary in the local array
      if (this.indxBene !== undefined && this.indxBene >= 0) {
        const updatedClient = await this.reservationService.getClientbyID(this.ClientUpdaed.id).toPromise();
        if (updatedClient) {
          this.Item.beneficiaries[this.indxBene] = updatedClient;
          this.beneficiaries[this.indxBene] = updatedClient;
        }
      }
      
      // Mark this guest as completed
      this.completedGuests.add(this.currentEditingGuestIndex);
      
      // Reprocess beneficiaries
      this.processBeneficiaries();
      
      return true;
      
    } catch (error) {
      console.error('Error updating guest:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update guest information. Please try again.'
      });
      return false;
    }
  }

  async goToNextGuest(): Promise<void> {
    const saved = await this.saveCurrentGuestAndContinue();
    if (saved && this.currentEditingGuestIndex < this.beneficiaries.length - 1) {
      this.editGuest(this.beneficiaries[this.currentEditingGuestIndex + 1], this.currentEditingGuestIndex + 1);
    }
  }

  async goToPreviousGuest(): Promise<void> {
    if (this.currentEditingGuestIndex > 0) {
      // Save current guest first
      await this.saveCurrentGuestAndContinue();
      this.editGuest(this.beneficiaries[this.currentEditingGuestIndex - 1], this.currentEditingGuestIndex - 1);
    }
  }

  selectGuestToEdit(index: number): void {
    if (index !== this.currentEditingGuestIndex) {
      // Save current before switching
      this.saveCurrentGuestAndContinue().then(() => {
        this.editGuest(this.beneficiaries[index], index);
      });
    }
  }

  async submitAndDownloadFiche(): Promise<void> {
    this.isSubmitting = true;
    
    try {
      // Save all guests first
      let allSaved = true;
      for (let i = 0; i < this.beneficiaries.length; i++) {
        const saved = await this.saveGuest(i);
        if (!saved) {
          allSaved = false;
        }
      }
      
      if (!allSaved) {
        this.isSubmitting = false;
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please complete all required fields for each guest.'
        });
        return;
      }
      
      // Check if all guests are complete
      if (!this.areAllGuestsComplete()) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Incomplete Guest Information',
          text: 'Some guest information is incomplete. Do you want to continue anyway?',
          showCancelButton: true,
          confirmButtonText: 'Continue',
          cancelButtonText: 'Complete Info'
        });
        
        if (!result.isConfirmed) {
          this.isSubmitting = false;
          return;
        }
      }
      
      // Open the fiche de police component to download
      await this.downloadFicheDePolice();
      
    } catch (error) {
      console.error('Error submitting:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred. Please try again.'
      });
    } finally {
      this.isSubmitting = false;
    }
  }

  async downloadFicheDePolice(): Promise<void> {
    try {
      const modalRef = this.modalService.open(FichedepoliceComponent, {
        size: 'sm',
        windowClass: 'guest-registration-modal',
        centered: true,
        scrollable: true
      });
      
      modalRef.componentInstance.OrderGeted = this.OrderGeted;
      modalRef.componentInstance.resa = this.resa;
      modalRef.componentInstance.Item = this.Item;
      modalRef.componentInstance.Payments = this.OrderGeted.payments || [];
      modalRef.componentInstance.Notes = this.Item.notes || [];
      modalRef.componentInstance.autoDownload = true; 
      
      modalRef.result.then((result) => {
        if (result) {
          // Swal.fire({
          //   icon: 'success',
          //   title: 'Success',
          //   text: 'Your pre-check-in has been completed and the registration form has been downloaded.',
          //   timer: 3000,
          //   showConfirmButton: false
          // });
        }
      }).catch(() => {});
      
    } catch (error) {
      console.error("An error occurred:", error);
      Swal.fire({
        title: "An error occurred",
        text: "Unable to download the Guest Registration Form",
        icon: "error",
        confirmButtonText: 'OK'
      });
    }
  }

  // Keep for backward compatibility but it's now unused
  async confirmGuestUpdate(): Promise<void> {
    const saved = await this.saveCurrentGuestAndContinue();
    if (saved) {
      this.ClientSeleted = false;
      this.currentEditingGuestIndex = -1;
      
      Swal.fire({
        icon: 'success',
        title: 'Guest Updated',
        text: 'Guest information has been saved successfully.',
        timer: 2000,
        showConfirmButton: false
      });
    }
  }

  cancelGuestEdit(): void {
    this.ClientSeleted = false;
    this.DayCustomerBirthd = null;
    this.MounthCustomerBirthd = null;
    this.YearCustomerBirthd = null;
    this.indxBene = undefined;
    this.ClientComplete = false;
    this.countrySearchResults = [];
    this.nationalitySearchResults = [];
    this.CustomerSubDocType = null;
    this.filteredSubDocTypes = [];
    this.currentEditingGuestIndex = -1;
  }

  selectedCountry(index: number): void {
    this.ClientUpdaed.country = { ...this.Countries[index] };
    this.countrySearchResults = [];
  }

  selectedNationality(index: number): void {
    this.ClientUpdaed.nationality = this.Nationalities[index].name;
    this.nationalitySearchResults = [];
  }

  comparMounthFn(month1: any, month2: any): boolean {
    return month1 === month2;
  }

  comparDocTypeFn(doctypeA: any, doctypeB: any): boolean {
    return doctypeA && doctypeB ? doctypeA.docTypeId === doctypeB.docTypeId : doctypeA === doctypeB;
  }

  async getDocumentTypes(): Promise<void> {
    try {
      let results = await this.checkInService.getAlldoucument().toPromise();
      this.ListTypedocument = results?.content || [];
    } catch (error) {
      console.error('Error loading document types:', error);
      this.ListTypedocument = [];
    }
  }

  areAllGuestsComplete(): boolean {
    if (!this.beneficiaries || this.beneficiaries.length === 0) return false;
    
    return this.beneficiaries.every(guest => this.isGuestComplete(guest));
  }

  // Keep for backward compatibility
  async openGuestRegistrationForm(): Promise<void> {
    await this.downloadFicheDePolice();
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'UNCHECKEDIN': return 'status-reserved';
      case 'INHOUSE': return 'status-inhouse';
      case 'CHECKEDOUT': return 'status-checkedout';
      case 'CANCELLED': return 'status-cancelled';
      case 'NOSHOW': return 'status-noshow';
      case 'PRECHECKIN': return 'status-precheckin';
      default: return 'status-default';
    }
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'UNCHECKEDIN': return 'Reserved';
      case 'INHOUSE': return 'In House';
      case 'CHECKEDOUT': return 'Checked Out';
      case 'CANCELLED': return 'Cancelled';
      case 'NOSHOW': return 'No Show';
      case 'PRECHECKIN': return 'Pre Check-In';
      default: return status;
    }
  }

  getTotalPrice(): string {
    if (!this.Item || !this.Item.prices) return '0.00';
    
    const totalPrice = this.Item.prices.find((p: any) => p.scope === 'TOTAL');
    if (totalPrice) {
      return `${totalPrice.value.toFixed(2)} ${totalPrice.currency}`;
    }
    return '0.00';
  }
}